<template>
    <!-- footer -->
    <div class="footer-wrapper">
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="footer__content">
                            <div class="footer__social">
                                <img style="width: 100px;" src="assets/img/logoSvg.svg" alt="">
                            </div>
                            <span>
                                <small class="footer__copyright">Powered by ELGEDEES </small>
                                <small class="footer__copyright">Designed by BYTE © 2021</small>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
    <!-- end footer -->
</template>

<script>
export default {
    name: 'AppFooter'
}
</script>

<style>
.footer-wrapper {
    text-align: center;
}
</style>